import React from 'react';

// Catches render-time crashes anywhere below it and shows a recovery screen
// instead of a blank white page. Without this, one thrown error in any
// component unmounts the whole React tree.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, background: 'var(--theme-bg, #0f1115)', color: 'var(--theme-text, #e8eaed)',
        fontFamily: 'inherit', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 380 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 10 }}>Something went wrong</h1>
          <p style={{ fontSize: 14, opacity: 0.7, marginBottom: 20, lineHeight: 1.5 }}>
            The app hit an unexpected error. Your data is safe — reloading usually fixes it.
          </p>
          <p style={{ fontSize: 12, opacity: 0.45, marginBottom: 20, wordBreak: 'break-word', fontFamily: 'monospace' }}>
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px', borderRadius: 12, border: '1px solid rgba(61,134,204,0.5)',
              background: 'rgba(61,134,204,0.22)', color: 'var(--theme-text, #e8eaed)',
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
